export const buttonStyles = {
  p: 2,
  ml: 1,
  textTransform: 'none',
  letterSpacing: '1px',
  height: '55px',
  fontsize: '1rem'
};